import type { ValueOf } from '@kc-console/core';

export type EnumType<T extends { [key: string]: string }> = {
  [Key in keyof T]: T[Key];
} & {
  isValid(value: unknown): value is T[keyof T];
  values(): T[keyof T][];
};

export const StackDirection = (() => {
  const enums = {
    Vertical: 'vertical',
    Horizontal: 'horizontal',
  } as const;

  const values = Object.values(enums);
  const isValid = (value: unknown): value is ValueOf<typeof enums> => values.some(v => v === value);

  const enumValue = {
    ...enums,
    values: () => values,
    isValid,
  } as const satisfies EnumType<typeof enums>;

  const toFlexDirection = (value: ValueOf<typeof enums>) =>
    value === enums.Vertical ? 'column' : 'row';

  const methods = {
    toFlexDirection,
  };

  return Object.freeze({ ...enumValue, ...methods });
})();
export type StackDirection = ValueOf<ReturnType<(typeof StackDirection)['values']>>;
